<template>
  <div v-click-outside="() => toggleDropDown(false)" class="dropdown-select">
    <div @click="toggleDropDown(!isDropDownOpen)" class="dropdown-select__btn">
      <span class="dropdown-select__text">{{ $t(currentLocaleTitle) }}</span>
      <i class="icon-down-arrow dropdown-select__icon"></i>
    </div>
    <ul v-if="isDropDownOpen" class="dropdown-select__list">
      <li
        v-for="locale in locales"
        :key="locale.code"
        class="dropdown-select__item"
        :class="{
          'dropdown-select__item--disabled':
            currentLocaleTitle === locale.name,
        }"
        @click="setLang(locale.code)"
      >
        <span class="dropdown-select__link text-black">{{ $t(locale.name) }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
import { LOCALE } from '@/helpers/locale'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LocaleSwitcher',
  data () {
    return {
      isDropDownOpen: false
    }
  },
  computed: {
    ...mapState('locale', ['locale']),
    currentLocaleTitle () {
      return this.locales.find((el) => el.code === this.locale).name
    },
    locales () {
      return Object.values(LOCALE)
    }
  },
  methods: {
    ...mapActions('locale', ['setLocale']),
    toggleDropDown (val) {
      this.isDropDownOpen = val
    },
    setLang (lang) {
      this.setLocale(lang)
      this.toggleDropDown(false)
    }
  }
}
</script>
<style lang="scss" scoped>
.dropdown-select__link {
  cursor: pointer;
}
</style>
